'use client';

import { useEffect } from 'react';

// WHY: заставку рисует корневой layout — узел принадлежит React; удалённый руками, он ломает первый же мягкий переход
// (вики в Mini App) ошибкой insertBefore/removeChild, поэтому прячем, а не удаляем
export function removeSplash(): void {
  const splash = document.getElementById('splash');
  if (splash) splash.style.display = 'none';
}

export function useRemoveSplash(): void {
  useEffect(() => {
    removeSplash();
  }, []);
}
